import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { LogService } from '../../../services/log.service';
import { TranslationService } from '../../../services/translation.service';
import { ConfigService } from '../../../services/config.service';
import { DataIoService } from '../../../services/data-io.service';
import { ValueChangedConfirmation } from '../../../classes/ValueChangedConfirmation';
import { Helper, MenuNode, BaseSensor, ISensorInterface } from '../../../classes';

@Component({
    selector: 'basic-settingsvalue',
    templateUrl: './settingsvalue.component.html',
    styleUrls: ['./settingsvalue.component.scss']
})
export class SettingsvalueComponent implements OnInit {    	

    _on:boolean=true;
    b():string{
        if(!this._on){
            return '';
        }
        return this.getValue()+"";
    }
    s():string{
        if(this.type == 'servicedate'){
            return 'd.161';
        }
        if(this.isDiagnoseCode()){
            return this.node.getTitle().toLowerCase();
        }
        return '';
    }


    unit():string{
        if(!this._on){
            return '';
        }
        if(Number.isNaN( Number.parseFloat( this.b() ) ) ){
            this._unit = '';
        }else{
            if(this._sensor){
                return this._sensor.getRawUnit();
            }else{
                return '';
            }
        }

    }

    @Input('debug') debug: false;
    enabled_buttons: Array<string>;

    title: string = "";
    subTitle: string = "";
    _unit: string = "STD_UNIT_CELSIUS_NORMAL_LEFT";
    min: number;
    max: number;
    circular : boolean = false;
    menuIcon : string = "";
    node: MenuNode = null;
    _value: any;
    _sensor : BaseSensor;
    get value():any{
        return this._value;
    }

    set value(v:any){
        this._value = v;
    }


    steps: number = 0.1;
    dashIcon: string = "";
    buttonSubscription$: any;
    showMarker = false;
    showTexts = false;
    showTextInput = false;
    darkTitle = false;
    brightText = false;
    brightText1 = false;
    brightText2 = false;
    brightText3 = false;
    numberStyle = "int";
    type: string;
    pans=0;
    panSkip=4;
    _valueLeft=0;
    valueLeft="0%"
    constructor(
        private menuService: MenuService, 
        private ioService: DataIoService, 
        private logger: LogService, 
        private config: ConfigService, 
        private translator:TranslationService) {
        this.node = menuService.getCurrentNode();
        console.log("Initializing SettingsvalueComponent. Node: "+this.node.getIdentifier());
    }

    isBlinking: boolean;
    unitBlinking: boolean;
    // blinkende werte (code falsch eingegeben)
    blinkValue(duration?:number){

        let _duration = duration;
        
        if(duration === undefined){
            _duration = 1000; 
        }
        
        this.isBlinking = true;
        if(_duration > 0){
            setTimeout(() => {
                this.isBlinking = false;
            }, _duration);
        }
    }

    _blinkHandler:any;
    blinkValueAndUnit(){
        this._blinkHandler = setInterval(()=>{
            this._on = !this._on;
        },400);
    }
    changed=false;
    // blinkende buttons (z.B. nach veränderung)
    blink(){
        if(!this.changed){
            this.changed = true;
            this.menuService.blinkButton('confirm');
        }
    }
    temperatureForTimeFrameEventHandler(event) {
        if (event != "confirm") {
            this.menuService.resetTimeout();
        }
        switch (event) {
            case 'panup':{
                this.blink();
                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    return;
                }

            }
            case 'up':{
                this.blink();
                this.temperatureEventHandler('up');
                return;
            }
            case 'pandown':{
                this.blink();
                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    return;
                }
            }
            case 'down':{
                this.blink();
                this.temperatureEventHandler('down');
                return;
            }
            
            case 'confirm': {

                let timeframe = this.ioService.getCurrentTimeFrame();
                this.ioService.currentTimeFrame.setValue(this.value);
                let zone = this.node.get('zone');
                let day = this.node.get('day');
                let table = this.node.get('table');
                if(table == 'heating'){
                    timeframe.setIgnoreTemperature(false);
                }
                let mode = this.node.get('mode');
                if (mode == "add") {
                    this.ioService.deviceInfo().getZoneById(parseInt(zone)).getTimeFrameManager(table).addTimeFrame(timeframe);
                }
                if (mode == "edit") {
                    let id = this.node.get('id');

                    let tfm = this.ioService.deviceInfo().getZoneById(parseInt(zone)).getTimeFrameManager(table);
                    if (tfm) {
                        tfm.patch(parseFloat(id), timeframe);
                    } else {
                        this.logger.debug("TimeFrame-Manager is null.");
                    }
                }
                let cnfmtn = undefined; //new ValueChangedConfirmation('timeframe','0','1',this.node);
                if(this.node.hasTarget()){
                    let target = this.node.getTargetNode();
                    if(target){
                        if(!this.node.hasParameter('')){
                            this.menuService.goto(target,cnfmtn);
                        }else{
                            this.menuService.goto(target,undefined);
                        }
                        return;
                    }
                }
                if(!this.menuService.historyBack(cnfmtn)){
                    this.menuService.hierarchyUp(false,cnfmtn);
                    return;
                }else{
                    return;
                }
            }
            case 'back': {
                this.backClicked();
                return;
            }
            case 'question':{
                this.menuService.showHelp();
                return;
            }
        }
    }
    backClicked(){

        this.logger.debug("Back clicked.");
        if(this.node.hasBackTarget()){
            this.logger.debug("Goto backtarget ");
            let backTarget = this.node.getBackTargetNode()
            if(backTarget){
                this.logger.debug("Backtarget is: "+backTarget.getTitle());
            }else{
                console.error("Backtarget not found on "+this.node.getIdentifier());
            }
            this.menuService.goto(backTarget);
            return;
        }

        if (this.node.getType() == "code") {
            this.logger.debug("Goto hierarchy up");
            this.menuService.hierarchyUp();
            return;
        }
        this.logger.debug("Goto history back");
        if(!this.menuService.historyBack()){
            this.logger.debug("failed. going hierarchy up");
            this.menuService.hierarchyUp();
            return;
        }
    }
    getAlignment():string{
        if(this.type == 'servicedate'){
            if(this.dateStep == 'day'){
                return 'left';
            }
            return 'right';
        }
        if(this.type=='countdown'){
            return 'left';
        }else{
            return 'right';
        }
    }
    _sd : Date;
    _b = undefined;
    _s = undefined;
    dateSteps = ['day','month','year'];
    dateStep = 'day';
    serviceDateHandler(event){
        if(event == 'confirm'){
            if(this.dateStep == 'day'){
                this.dateStep = 'month';
                return;
            }
            if(this.dateStep == 'month'){
                this.dateStep = 'year';
                return;
            }
            if(this.dateStep == 'year'){
                this.ioService.setServiceDate(this._sd);
                this.menuService.hierarchyUp(true,undefined);
                return;
            }
        }
        if(event == 'back'){
            if(this.dateStep == 'day'){
                this.menuService.hierarchyUp(true,undefined);
                return;
            }
            if(this.dateStep == 'month'){
                this.dateStep = 'day';
                return;
            }
            if(this.dateStep == 'year'){
                this.dateStep = 'month';
                return;
            }
        }
        if(event == 'up'){
            this.increase();
            return;
        }
        if(event == 'down'){
            this.decrease();
            return;
        }
    }

    increase(val?:number){
        if(!val){
            val=1;
        }
        let day = this._sd.getDate();
        let month = this._sd.getMonth();
        let year = this._sd.getFullYear();
        let hours = this._sd.getHours();
        let minutes = this._sd.getMinutes();
        let seconds = this._sd.getSeconds();
        let cyclic = false; // is 23 hours + 1 hour = 0 hours possible?
        // tage der monate
        let moduls = [31, (year % 4 == 0)?29:28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        switch(this.dateStep){
            case 'day':{
                let newDay = day+val;
                if(cyclic){
                    if(newDay < 1){
                        newDay = moduls[month];
                    }
                    if(newDay > moduls[month]){
                        newDay = 1;
                    }
                }else{
                    if(newDay < 1){
                        newDay = 1;
                    }
                    if(newDay > moduls[month]){
                        newDay = moduls[month];
                    }
                }

                this._sd = new Date(year,month,newDay,hours,minutes,seconds);

                return;
            }
            case 'month':{
                let newMonth = ( (month+val)%(12) );
                if(!cyclic){
                    if(month == 11 && val > 0){
                        newMonth = 11;
                    }
                    if(month == 0 && val < 0){
                        newMonth = 0;
                    }
                }
                let newDay = day;

                while(newDay > moduls[newMonth]){

                    newDay--;
                }
                this._sd = new Date(year,newMonth,newDay,hours,minutes,seconds);

                return;
            }
            case 'year':{
                if(this._sd.getFullYear() == 2099 && val > 0){
                    if(cyclic){
                        this._sd.setFullYear(2001);
                    }
                    return;
                }
                if(this._sd.getFullYear() == 2001 && val < 0){
                    if(cyclic){
                        this._sd.setFullYear(2099);
                    }
                    return;
                }

                this._sd.setFullYear(this._sd.getFullYear()+val);
                return;
            }
            default:{
            }
        }
    }
    decrease(val?:number){
        if(!val){
            val=1;
        }
        this.increase(-1*val);
    }
    serviceDateSetup(){
        this.type = 'servicedate';
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe( (event)=>{this.serviceDateHandler(event);});
        this.b = ()=>{
            switch(this.dateStep){
                case 'day':{
                    return ' '+Helper.twoDigits(this._sd.getDate());
                }
                case 'month':{
                    return ''+Helper.twoDigits(this._sd.getMonth()+1);
                }
                case 'year':{
                    return ''+(this._sd.getFullYear());
                }
            }
            return '';
        }

        this.s = ()=>{return this._s;}
        this._s = 'd.161';
        this._sd = this.ioService.getServiceDate();


    }
    temperatureEventHandler(event) {
        //this.panSkip=1;
        if (event != "confirm") {
            this.menuService.resetTimeout();
        }

        switch (event) {

            case 'question':{
                this.menuService.showHelp();
                return;
            }

            case 'panup':{
                this.blink();
                
                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){

                    return;
                }
            }

            case 'up': {
                this.blink();
                console.log("Up clicked, value was "+this.value+", adding "+this.steps);
                this.value = parseFloat(""+this.value);
                this.value += this.steps;
                this.value = Math.round(100 * this.value) / 100;

                if (!this.circular && this.value > this.max) {
                    console.log("max-value reached ("+this.max+")");
                    this.value = this.max;
                }else if(this.circular && this.value > this.max){
                    console.log("max-value reached ("+this.max+")");
                    this.value = this.min;
                }
                if(this.node.hasParameter('immediate')){
                    this.node.onConfirm(this.value);
                }
                if(this._sensor && this._sensor.hasSpecialValue(this.value)){
                    let sv = this._sensor.getSpecialValue(this.value);
                    if(this.hasParameter('showSpecialValueIcons') && sv.hasIcon()){
                        this._valueIsIcon = true;
                    }else{
                        this._valueIsIcon = false;
                    }
                }else{
                    this._valueIsIcon = false;
                }
                console.log("Up clicked, value now: "+this.value);
                return;
            }

            case 'pandown':{
                this.blink();
                
                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){

                    return;
                }
            }
            
            case 'down': {
            	
                this.blink();
                this.value -= this.steps;
                this.value = Math.round(100 * this.value) / 100;
                if (!this.circular && this.value < this.min) {
                    this.value = this.min;
                }else if(this.circular && this.value < this.min){
                    this.value = this.max;
                }
                if(this.node.hasParameter('immediate')){
                    this.node.onConfirm(this.value);
                }
                
                if(this._sensor && this._sensor.hasSpecialValue(this.value)){
                    let sv = this._sensor.getSpecialValue(this.value);
                    if(this.hasParameter('showSpecialValueIcons') && sv.hasIcon()){
                        this._valueIsIcon = true;
                    }else{
                        this._valueIsIcon = false;
                    }
                }else{
                    this._valueIsIcon = false;
                }
                return;
            }

            case 'confirm': {
                if (this.node.getType() == "code") {
                    this.ioService.deviceInfo().getScale('last_code').setCurrentValue(this.getValue());

                    if (!([35,96].includes( parseInt( this.getValue() )) )) {
                        this.logger.debug("this.getValue:" + this.getValue() + " does not match " + this.ioService.deviceInfo().getScaleValue('code'));
                        this.blinkValue();
                        return;
                    }else{
                        this.ioService.startCodeReset();
                    }

                }

                //console.log("Confirm.");

                let confirmation = this.node.onConfirm(this.value);
                if(this.node.hasConditionalTargets()){
                    console.log("Current node has conditional targets.");
                    let conditionalTarget = this.node.getConditionalTargetNode();
                    console.log("found conditional target:"+conditionalTarget);
                    this.menuService.goto(conditionalTarget,confirmation);
                    return;                        
                }
                if(this.isDiagnoseCode()){
                    this.menuService.hierarchyUp(false,undefined);
                }

                if (this.node.hasTarget()) {
                    //console.log("has target.");
                    let target = this.node.getTargetNode();

                    if (target) {
                        //console.log("going to "+target.getIdentifier());
                        this.menuService.goto(target,confirmation);
                        return;
                    }else{
                        //console.log("target empty: "+this.node.getTarget());
                    }
                }
                return;
            }
            case 'back': {
                if (this.node.getType() == "code") {
                    this.ioService.startCodeReset();
                }
                this.backClicked();
                return;
            }
        }
    }

    isDiagnoseCode(){
        return this.node.getParent().getIdentifier().startsWith('diagnoseCode');            
    }
    hasParameter(p:string):boolean{
        return this.node.hasParameter(p);
    }
    currentChar: any;
    currentCharChanged(char) {
        this.logger.debug("Current char changed to " + char);
        if (char === undefined) {
            return;
        }
        if (char == "") {
            this.currentChar = false;
        } else {
            this.currentChar = char;
        }
    }

    saveText(text) {
        if (text != undefined && text != null) {
            let confirmation = this.node.onConfirm(text);
            if(this.node.hasTarget()){
                let target = this.node.getTargetNode();
                if(target){
                    this.menuService.goto(target,confirmation);
                    return;
                }
            }

            this.menuService.hierarchyUp(confirmation);
        } else {
            this.logger.debug("Text is undefined in onSave-Listener.");
        }
    }

    textChanged(text) {

        if (text == undefined) {
            this.logger.debug("text changed to undefined.");
            return;
        }
        this.value = text;
        this.updateValueLeft();
    }

    // abstand nach links..
    updateValueLeft(){
        if(this.value.length > 9){
            this._valueLeft = (this.value.length -9);
            
        }else{
            this._valueLeft=0;
        }
        this.valueLeft = (-0.75*this._valueLeft)+"em";
    }
    stringEventHandler(event) {
        if (event != "confirm") {
            this.menuService.resetTimeout();
        }
        // textinput kümmert sich um den rest.
        switch (event) {
            case 'back': {
                this.logger.debug("Going back in history.");
                this.menuService.historyBack();
                return;
            }
            case 'question':{
                this.menuService.showHelp();
                return;
            }
        }
    }
    get lightTitle(){
        return this.hasParameter('lightTitle');
    }
    get lightSubtitle(){
        return this.hasParameter('lightSubtitle');
    }

    countdownIteration(){
        this.value -=1;
        if(this.value > 0){
            this.startCountdown();
        }else{

            this.node.onConfirm(undefined);
            //console.log("Locked: "+this.ioService.getDeviceInfo().getValue('buttonlock'));
            this.menuService.goto(this.node.getTargetNode().getIdentifier());
        }
    }
    private countDown = null;
    private countdownRunning = false;
    startCountdown(){
        this.countdownRunning = true;
        this.countDown = setTimeout(()=>{
            this.countdownIteration();
        },1000);

    }
    delayHandle : any = undefined;
    delayed :boolean = false;

    startDelayTimer(){
        if(this.delayHandle){
            clearTimeout(this.delayHandle);
        }
        this.delayHandle = setTimeout(
            ()=>{
                this.delayed = false;
                this.delayHandle = undefined;
            },500);
    }


    ngOnInit() {
        //console.log("Init." + this.node.getType());
        
        if (this.node.hasParameter('zeitprogrammassistent')) {
            this.darkTitle = true;
            this.brightText = true;
        }
        if(this.node.hasParameter('loadDelay')){
            this.delayed = true;
            this.startDelayTimer();
        }
        if(this.node.hasParameter('brightText')){
            this.brightText = true;
        }
        if(this.node.hasParameter('brightText1')){
            this.brightText1 = true;
        }
        if(this.node.hasParameter('brightText2')){
            this.brightText2 = true;
        }
        if(this.node.hasParameter('brightText3')){
            this.brightText3 = true;
        }
        if(this.isDiagnoseCode()){
            this.blinkValueAndUnit();
        }
        this.type = this.node.getType();
        this.menuService.onElementFocused(this.node);
        if(this.isDiagnoseCode()){
            let parent = this.node.getParent();
            if(parent){
                this.ioService.infoTextAvailable(parent);
            }
        }
        switch (this.type) {
            case 'servicedate':{
                this.serviceDateSetup();
                return;
            }
            case 'countdown':{
                this._unit = '';
                this.title = this.node.getTitle();
                this.value = this.node.getValue();
                this.startCountdown();
                return;
            }
            case 'temperature': {
                this.configureTemperatureSetter();
                return;
            }
            case 'numberstring': {

            }
            case 'string': {
                this.configureStringSetter();
                return;
            }
            case 'timeframe-temperature': {
                this.timeframeTemperatureSetter();
                return;
            }
            case 'changecode': {

            }
            case 'code': {
                let code_id='last_code';
                this.circular = true;
                this.ioService.stopCodeReset();
                let scale = this.ioService.deviceInfo().getScale(code_id);
                if(!scale){
                    scale = BaseSensor.fromArgs(code_id,0,0,99,1,"");
                    this.ioService.deviceInfo().setScale(code_id,scale);
                }


                this.node.setValue(scale.getCurrentValue());

            }
            case 'number': {
                this.defaultSetup();
                this.circular = this.hasParameter('circular');
                this.value = (this.node.getValue());
                this._unit = "";
                this.numberStyle = "twodigit";
                this.steps = 1;
                this.min = 0;
                this.max = 99;
                if (this.value == 0) {
                    this.value = "00";
                }
                break;
            }
            default: {
                this.defaultSetup();
                if(!this.value){
                    this.value = 0;
                    this._unit = "";
                    
                }
            }
        }

    }

    defaultSetup() {
        //this.panSkip = 5;
        this.title = this.node.getTitle();
        this.subTitle = this.node.getSubTitle();
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.temperatureEventHandler(event); }
            );
        this.showMarker = true;
        this.showTexts = true;


        this.showTextInput = false;
        let sensor = this.node.getOnConfirmTarget();



        
        
        if (sensor instanceof BaseSensor) {
            this._unit = sensor.getUnit();
            this.steps = sensor.getGranularity();
            this.min = sensor.getMinValue();
            this.max = sensor.getMaxValue();
            this.value = (sensor.getCurrentValue());
            this._sensor = sensor;
            if (this.steps <= 0.1) {
                this.numberStyle = "twodecimals";
            }
            //console.log("Setup with sensor "+sensor.toString());
        } else {
            //console.log("Sensor not found for element "+this.node.getIdentifier());
            this._unit = "STD_UNIT_CELSIUS_NORMAL_LEFT";
            this.steps = 0.1;
            this.max = 30;
            this.min = 5;
            this.value = this.node.getValue();
            if(!this.value){
                this.value = 0;
            }
        }
    }
    ngOnDestroy() {
        if(this._blinkHandler){
            clearInterval(this._blinkHandler);
        }
        if(this.buttonSubscription$){
            this.buttonSubscription$.unsubscribe();
        }
        if(this.countDown){
            clearTimeout(this.countDown);
        }
        if(this.delayHandle){
            clearTimeout(this.delayHandle);
            this.delayHandle = undefined;
        }
    }

    _valueIsIcon:boolean=false;
    
    valueIsIcon(){
        return this._valueIsIcon;
    }

    getValue(){
        if(this.delayed){
            return '---';
        }
        if(this.type == "countdown"){
            return this.value;
        }
        if (this.type == "numberstring" || this.type == "string") {
            return this.value;
        }
        if(this._sensor instanceof BaseSensor){
            if(this._sensor.isList()){
                return this._sensor.getValueAt(this.value);
            }
            if(this._sensor.hasSpecialValue(this.value)){
                let sv = this._sensor.getSpecialValue(this.value);
                if(this._sensor && this._sensor.hasSpecialValue(this.value)){
                    let sv = this._sensor.getSpecialValue(this.value);
                    console.log("Value "+this.value+ " is special on this sensor.");
                    if(this.hasParameter('showSpecialValueIcons') && sv.hasIcon()){
                        this._valueIsIcon = true;
                        return sv.getIcon();
                    }else{
                        this._valueIsIcon = false;
                        return this.translator.tr(sv.getReplacement(),'en');
                    }
                }else{
                    this._valueIsIcon = false;
                    return this.value;
                }

            }else{
                this.logger.debug("has no special value for "+this.value);
            }
        }else{
            this.logger.debug("has no sensor.");
        }
        
        if (parseInt(this.steps.toString()) == this.steps) { // ganzzahlig.
            if (this.type == "code" || this.type == "changecode") {
                return Helper.twoDigits(this.value);
            }
            return this.value;
        }
        if (this.steps < 1 && this.steps >= 0.1) {
            return this.value.toFixed(1);
        }
        return this.value.toFixed(2);

    }


    getUnit() {
        if(this._sensor instanceof BaseSensor){
            if(this._sensor.isList()){
                return this._sensor.getUnitFor(this.value);
            }
            if(!this._sensor.hasSpecialValue(this.value)){
                return this.translator.tr(this._sensor.getUnit(),'en');
            }else{
                return '';
            }
        }
        return this.translator.tr(this._unit);
    }



    configureStringSetter() {
        this.showMarker = false;
        this.showTexts = false;
        this._unit = "";
        this.value = this.node.getValue();
        this.showTextInput = true;
        this.title = this.node.getTitle();

        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.stringEventHandler(event); }
            );
    }


    timeframeTemperatureSetter() {
        //this.panSkip = 2 ;
        this.title = this.node.getTitle();
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.temperatureForTimeFrameEventHandler(event); }
            );
        this.showMarker = true;
        this.showTexts = true;

        this.showTextInput = false;
        let sensor = this.node.getOnConfirmTarget();
        if(sensor instanceof BaseSensor){
            this._sensor = sensor;
        }
        this.value = parseInt(this.node.get('value'));
        this.logger.debug("Temperature Setter: ");
        this.logger.debug(this.value);
        this._unit = "STD_UNIT_CELSIUS_NORMAL_LEFT";
        this.steps = 0.5;
        this.max = 30;
        this.min = 5;
    }



    configureTemperatureSetter() {
        //this.panSkip=3;
        this.title = this.node.getTitle();
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { 
                this.temperatureEventHandler(event);
            }
            );
        this.showMarker = true;
        this.showTexts = true;
        this.menuIcon = this.node.getIcon();
        this.showTextInput = false;

        let sensor = this.node.getOnConfirmTarget();
        if (sensor instanceof BaseSensor) {
            this.logger.debug("Configuring with sensor: ");
            this.value = sensor.getCurrentValue();
            this._unit = sensor.getUnit();
            this.steps = sensor.getGranularity();
            this.max = sensor.getMaxValue();
            this.min = sensor.getMinValue();
            this.circular = this.node.getTemplateParameters().includes('circular');
            if(this.circular){
                //console.log("Value is circular: "+JSON.stringify(this.node.getTemplateParameters()));
            }else{
                //console.log("value is not circular."+JSON.stringify(this.node.getTemplateParameters()));
            }

            this._sensor = sensor;
        } else {
            if (this.node.getValue()) {
                this.value = this.node.getValue();
                this._unit = "STD_UNIT_CELSIUS_NORMAL_LEFT";
                this.steps = 0.5;
                this.min = 5;
                this.max = 30;
            }
        }
    }
}
